var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WwiGermanHelmet50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M7,19c0-1.823,0.368-3.44,1.03-4.861c11.636-10.431,35.215-3.747,35.921,3.829 C43.983,18.306,43.999,18.65,44,19v8c-0.001,0.073,0.022,0.159,0.021,0.26C44,32,3.878,27.065,5.861,24.131 C6.542,23.122,7,21.79,7,20V19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#586a73",
    d: "M44,19c-1.73-3.92-4.39-5.74-7.32-6.92c-2.94-1.17-6.2-1.74-9.56-2c-3.39-0.25-6.75-0.21-10.04,0.35 c-3.27,0.61-6.45,1.54-9.4,4.56C9.93,8.8,17.45,6,24.97,6C35.34,6,43.99,10.79,44,19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M25.5 16A2.5 2.5 0 1 0 25.5 21A2.5 2.5 0 1 0 25.5 16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    d: "M25.5,22c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S27.43,22,25.5,22z M25.5,17 c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S26.327,17,25.5,17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d7581",
    d: "M26.97,40c-3,0-6-1-7.99-3c-2-2-4-7-12.99-7C3,30,0,29,0,28c0-0.03,0-0.06,0.02-0.09 c0.03-0.17,0.199-0.426,0.652-0.597C1.359,27.062,3.969,26,5.86,24.13C8.41,24.37,12.68,24.96,16,26c3.46,1.08,10.06,2,15.63,2 c4.9,0,9.15,0,12.39-0.74c0.25,1.77,2.8,7.71,3.92,9.74C48.47,37.96,45.94,40,26.97,40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WwiGermanHelmet50);
export default __webpack_public_path__ + "static/media/icons8-wwi-german-helmet-50.b386c1aaeadbfecd9131081eb2f358da.svg";
export { ForwardRef as ReactComponent };